<template>
    <client-page class="wrap wrap--sub">
        <sub-visual visual="시설·장비예약"></sub-visual>
        <!-- <sub-visual :visual="title" class="sv1"></sub-visual> -->
        <rental-navigation-row />

        <section class="section--sm section--first">
            <v-container>
                <rental-subject-card :item="subject" readonly />
            </v-container>
        </section>

        <section class="section--sm">
            <v-container>
                <h4 class="tit--sm mb-16 mb-lg-34">예약일시</h4>
                <v-row>
                    <v-col cols="12" lg="7" class="mb-20 mb-lg-0">
                        <v-card rounded="lg" elevation="0" class="border" :disabled="subject.isRentDisabled">
                            <div class="pa-20 pa-md-30 py-xl-50 px-xl-74">
                                <rental-schedule-date v-model="date" v-bind="{ loading }" class="v-sheet--outlined" />
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="5">
                        <v-card :disabled="subject.isRentDisabled" flat>
                            <div class="pl-lg-30 pt-lg-14">
                                <rental-schedule-time v-model="schedules" v-bind="{ loading, date, subject, limitationMet, schedulesOnCloud }" />
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="section--sm">
            <v-container>
                <h4 class="tit--sm mb-16 mb-lg-34">선택내용 확인</h4>
                <v-row align="center">
                    <v-col cols="12" md="2" xl="1">
                        <h5 class="tit-txt grey-dark--text">사용시간</h5>
                    </v-col>
                    <v-col cols="12" md="10" xl="11">
                        <h5 class="tit-txt grey-dark--text">
                            <rental-schedule-list v-bind="{ schedules }" />
                        </h5>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="section--sm section--last">
            <v-container>
                <h4 class="tit--sm mb-16 mb-lg-34">사용목적</h4>
                <v-textarea rounded outlined height="200" v-model="usage" class="rounded-lg" :placeholder="`사용 목적을 입력해주세요`" :disabled="subject.isRentDisabled" />
                <div class="button-group">
                    <v-btn v-bind="{ loading }" @click="$router.go(-1)" large outlined rounded color="grey" elevation="0" class="min-w-120px min-w-lg-200px"><span class="color-grey">취소</span></v-btn>
                    <v-btn v-bind="{ loading }" :disabled="subject.isRentDisabled" @click="save" large rounded color="primary" elevation="0" class="min-w-120px min-w-lg-200px"><span>예약신청</span></v-btn>
                </div>
            </v-container>
        </section>

        <!-- <section class="section">
            <v-container>
                <div class="tit-wrap tit-wrap--dot mt-60">
                    <h2 class="tit">예약 {{ typeText }}</h2>
                </div>
                <rental-subject-card :item="subject" readonly class="mt-40" />

                <div class="tit-wrap tit-wrap--dot mt-60"><h2 class="tit">예약 일시</h2></div>
                <v-row>
                    <v-col cols="auto">
                        <rental-schedule-date v-model="date" v-bind="{ loading }" class="v-sheet--outlined" />
                    </v-col>
                    <v-col>
                        <rental-schedule-time v-model="schedules" v-bind="{ loading, date, subject, limitationMet, schedulesOnCloud }" />
                    </v-col>
                </v-row>

                <div class="tit-wrap tit-wrap--dot mt-60"><h2 class="tit">선택내용 확인</h2></div>
                <rental-schedule-list v-bind="{ schedules }" />

                <div class="tit-wrap tit-wrap--dot mt-60"><h2 class="tit">사용목적</h2></div>
                <v-textarea v-model="usage" :placeholder="`사용 목적을 입력해주세요`" />

                <div class="v-btn-group--bottom">
                    <v-row justify="center" class="row--small">
                        <v-col cols="6" sm="auto">
                            <v-btn v-bind="{ loading }" large outlined block color="grey-d6" class="w-md-240px" @click="$router.go(-1)">취소</v-btn>
                        </v-col>
                        <v-col cols="6" sm="auto">
                            <v-btn v-bind="{ loading }" large block color="primary" class="w-md-240px" @click="save">예약신청</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section> -->

        <rental-limitation-per-week v-model="limitationPerWeekMet" v-bind="{ date, limitations, schedules }" />
    </client-page>
</template>

<script>
import api from "@/api";
import { RENTAL_SCHEDULE_STATES, RENTAL_SUBJECT_TYPES } from "@/assets/variables";

import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import RentalSubjectCard from "@/components/client/rental/rental-subject-card.vue";
import RentalScheduleDate from "@/components/client/rental/rental-schedule-date.vue";
import RentalScheduleTime from "@/components/client/rental/rental-schedule-time.vue";
import RentalScheduleList from "@/components/client/rental/rental-schedule-list.vue";
import RentalNavigationRow from "@/components/client/rental/rental-navigation-row.vue";
import RentalLimitationPerWeek from "@/components/client/rental/rental-limitation-per-week.vue";
import dayjs from "dayjs";

export default {
    components: {
        SubVisual,
        ClientPage,
        RentalSubjectCard,
        RentalScheduleDate,
        RentalScheduleTime,
        RentalScheduleList,
        RentalNavigationRow,
        RentalLimitationPerWeek,
    },
    props: {
        type: { type: String, default: RENTAL_SUBJECT_TYPES.EQUIPMENTS.value },
        _subject: { type: String, default: null },
    },
    data: () => ({
        loading: false,
        usage: null,
        date: dayjs().add(1, "day").format("YYYY-MM-DD"),

        subject: null,

        schedulesOnCloud: [],

        limitations: [],
        limitationPerWeekMet: false,

        schedules: [],
    }),
    computed: {
        typeText() {
            return RENTAL_SUBJECT_TYPES[this.type?.toUpperCase?.()]?.text || "";
        },
        // title() {
        //     return `${this.typeText}예약`;
        // },
        limitationMet() {
            return this.limitationPerWeekMet;
        },
    },
    mounted() {
        this.init().then(this.reroute).then(this.getSchedules);
    },
    watch: {
        date() {
            this.getSchedules();
        },
        _subject() {
            this.getSchedules();
        },
    },
    methods: {
        async init() {
            let { subject } = await api.v1.rental.subjects.get({ _id: this._subject });
            this.subject = subject;

            let { limitations } = await api.v1.rental.limitations.gets({ params: { uses: true } });
            this.limitations = limitations;
        },
        async reroute() {
            const path = `/rental/${this.subject?.type?.toLowerCase?.()}/${this.subject?._id}`;
            if (this.$route.path !== path) this.$router.replace({ path });
        },
        async getSchedules() {
            this.loading = true;
            try {
                let { _subject, date } = this;
                let { APPLIED, APPROVED } = RENTAL_SCHEDULE_STATES;
                let { schedules } = await api.v1.rental.schedules.gets({
                    params: { _subject, date, state: [APPLIED.value, APPROVED.value] },
                });
                this.schedulesOnCloud = schedules;
            } finally {
                this.loading = false;
            }
        },
        validates() {
            try {
                if (!this.$store.state.payload?._user) throw new Error("회원만 사용할 수 있습니다");

                if (this.$store.state.scope.includes("console")) throw new Error("관리자 계정으로는 사용할 수 없는 기능입니다");

                if (this.schedules.length < 1) throw new Error("스케줄을 선택해주세요");
                if (!this.usage) throw new Error("사용목적을 작성해주세요");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
        async save() {
            if (!this.validates()) return;
            this.loading = true;
            let { usage } = this;

            this.schedules = await Promise.all(
                this.schedules.map(async (schedule) => {
                    try {
                        return { ...((await api.v1.me.rental.schedules.post({ ...schedule, usage }))?.schedule || {}), success: true };
                    } catch (error) {
                        console.error(error);
                        return { ...schedule, success: false };
                    }
                })
            );
            let hasFailedItem = this.schedules.some(({ success }) => !success);
            if (hasFailedItem) {
                alert("예약 신청이 실패하였습니다.\n성공한 예약을 확인후 다시 신청해주세요.");
            } else {
                alert("예약 신청에 성공하였습니다");
            }
            (async () => {
                let requests = this.schedules
                    .reduce((requests, { _id, date }) => {
                        if (_id) {
                            let group = requests.find((group) => group.date == date);
                            if (!group) {
                                requests.push({ date, _schedules: [] });
                                group = requests[requests.length - 1];
                            }
                            group._schedules.push(_id);
                        }

                        return requests;
                    }, [])
                    .sort((a, b) => dayjs(a.date).isAfter(b.date));

                let { _subject } = this;
                let { type } = this.subject;

                requests = await Promise.all(
                    requests.map(async (request) => {
                        let { _schedules, date } = request;
                        let item = { _subject, _schedules, date, type, usage };
                        try {
                            return { ...((await api.v1.me.rental.requests.post(item)?.request) || {}), success: true };
                        } catch (error) {
                            console.error(error);
                            return { ...item, success: false };
                        }
                    })
                );
            })();

            this.loading = false;
            this.$router.push("/mypage/rental-requests");
        },
    },
};
</script>
